import type { JobEventKind, JobStatus, JobType, PostSource, PostStatus } from "./types.ts";

export const SOURCE_LABEL: Record<PostSource, string> = {
  author: "Авторский",
  news: "Новость",
  fact: "Факт",
  myth: "Миф",
  idea: "По запросу",
};

export const STATUS_LABEL: Record<PostStatus, string> = {
  draft: "Черновик",
  scheduled: "Запланирован",
  published: "Опубликован",
  failed: "Ошибка",
};

export const JOB_TYPE_LABEL: Record<JobType, string> = {
  author_turn: "Ход диалога",
  "auto:schedule": "Плановая подборка",
  "auto:news": "Новости",
  "auto:fact": "Факты",
  "auto:myth": "Мифы",
  "auto:idea": "Нужен пост",
  image: "Картинка Gemini",
};

export const JOB_STATUS_LABEL: Record<JobStatus, string> = {
  running: "Идёт",
  done: "Готово",
  failed: "Ошибка",
};

export const EVENT_KIND_LABEL: Record<JobEventKind, string> = {
  status: "Шаг",
  thinking: "Мысль",
  text: "Текст",
  search: "Поиск",
  fetch: "Страница",
  tool: "Инструмент",
  image: "Картинка",
  error: "Ошибка",
  done: "Готово",
};

export const AUTO_SOURCES: PostSource[] = ["news", "fact", "myth", "idea"];
/** Для запросов к базе: source IN (…) */
export const AUTO_SOURCES_SQL = AUTO_SOURCES.map((s) => `'${s}'`).join(",");

export const MAX_IMAGES = 10;
export const MAX_IMAGE_BYTES = 25 * 1024 * 1024;
export const IMAGE_MIME: Record<string, string> = {
  "image/jpeg": "jpg",
  "image/png": "png",
  "image/webp": "webp",
};
